import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import InboxChannelsAPI from '../../api/inboxChannels';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isCreating: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  create: async ({ commit }, { inbox_name, channels }) => {
    try {
      commit(types.default.SET_INBOXES_UI_FLAG, { isCreating: true });

      // Format channels payload
      const formattedChannels = channels.map(ch => ({
        channel_type: ch.type || ch.channel_type,
        channel_id: ch.channelId || ch.channel_id,
      }));

      const response = await InboxChannelsAPI.createWithChannels({
        inbox_name,
        channels: formattedChannels,
      });

      commit(types.default.ADD_INBOXES, response.data);
      commit(types.default.SET_INBOXES_UI_FLAG, { isCreating: false });

      return response.data.id; // Return inbox ID for navigation
    } catch (error) {
      commit(types.default.SET_INBOXES_UI_FLAG, { isCreating: false });
      return throwErrorMessage(error);
    }
  },
};

export const mutations = {
  [types.default.SET_INBOXES_UI_FLAG]($state, uiFlag) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlag };
  },
  [types.default.ADD_INBOXES]: MutationHelpers.create,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
